export const STRUCTURAL_WIDGET_TYPE_GROUP = 'structural';
